var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNewSearch = function SvgNewSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D1D1D1",
    fillRule: "evenodd",
    d: "M3 8.25a5.25 5.25 0 1 1 10.5 0 5.25 5.25 0 0 1-10.5 0M8.25 1.5a6.75 6.75 0 1 0 4.213 12.024l2.007 2.006a.75.75 0 1 0 1.06-1.06l-2.006-2.007A6.75 6.75 0 0 0 8.25 1.5",
    clipRule: "evenodd"
  })));
};
export default SvgNewSearch;